(() => {
  if (customElements.get('akbar-brand-video')) return;
  class BrandVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.mobile = matchMedia('(max-width: 768px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      this.updateSource = () => {
        this.video.src = this.mobile.matches && this.dataset.mobile ? this.dataset.mobile : this.dataset.desktop;
      };
      this.updateSource();
      const togglePlayback = () => this.video.paused ? this.video.play().catch(() => {}) : this.video.pause();
      this.video.addEventListener('click', togglePlayback, { signal: this.events.signal });
      this.video.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          togglePlayback();
        }
      }, { signal: this.events.signal });
      const sound = this.querySelector('button');
      sound.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        sound.setAttribute('aria-pressed', String(!this.video.muted));
        sound.setAttribute('aria-label', this.video.muted ? 'Unmute video' : 'Mute video');
      }, { signal: this.events.signal });
      this.mobile.addEventListener('change', this.updateSource, { signal: this.events.signal });
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !this.reducedMotion.matches) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      }, { threshold: 0.5 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  }
  customElements.define('akbar-brand-video', BrandVideo);
})();
